import { FormGroup, Input } from '@bigcommerce/big-design';

export function CreditCardForm({ payment, setPaymentInfo }) {
	return (
		<>
			<FormGroup>
				<Input
					type="text"
					label="Name On Card"
					value={payment.name_on_card}
					onChange={(event) =>
						setPaymentInfo(
							'name_on_card',
							event.currentTarget.value,
						)
					}
					required={true}
				/>
			</FormGroup>
			<FormGroup>
				<Input
					type="text"
					label="Card Number"
					value={payment.card_number}
					onChange={(event) =>
						setPaymentInfo('card_number', event.currentTarget.value)
					}
					required={true}
				/>
			</FormGroup>
			<FormGroup>
				<Input
					type="text"
					label="Expiration Month (MM)"
					value={payment.expiration_month}
					onChange={(event) =>
						setPaymentInfo(
							'expiration_month',
							event.currentTarget.value,
						)
					}
					required={true}
					maxLength={2}
				/>
			</FormGroup>
			<FormGroup>
				<Input
					type="text"
					label="Expiration Year (YYYY)"
					value={payment.expiration_year}
					onChange={(event) =>
						setPaymentInfo(
							'expiration_year',
							event.currentTarget.value,
						)
					}
					required={true}
					maxLength={4}
				/>
			</FormGroup>
			<FormGroup>
				<Input
					type="text"
					label="CVV"
					value={payment.cvv}
					onChange={(event) =>
						setPaymentInfo('cvv', event.currentTarget.value)
					}
					required={true}
					maxLength={4}
				/>
			</FormGroup>
		</>
	);
}
